
stateDefinitions = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'program.annualSurvey',
        url: '/survey'
        abstract: true
        permission: 'viewAnnualSurveys'
        templateUrl: 'empty'

    $stateProvider.state 'program.annualSurvey.index',
        url: ''
        templateUrl: 'programs/annualSurvey/index'
        resolve: surveys: resolveSurveys
        controllerAs: 'ctrl'
        controller: (@surveys, moment) ->
            today = moment()
            @lastCompletedEnd = today.year()
            @lastCompletedEnd -= 1 if today.quarter() != 4
            @currentStart = @lastCompletedEnd
            @currentEnd = @currentStart + 1
            @nextStart = @currentEnd


    $stateProvider.state 'program.annualSurvey.view',
        url: '/{year:int}'
        templateUrl: 'programs/annualSurvey/view'
        resolve: survey: resolveSurvey
        controllerAs: 'ctrl'
        controller: (@survey) ->



### @ngInject ###
resolveSurveys = (ModelService, program) ->
    return ModelService.getModelRelation(program, 'annual_surveys')


### @ngInject ###
resolveSurvey = ($stateParams, program, ModelService) ->
    id =  "annual_surveys/#{$stateParams.year}"
    return ModelService.getModelRelation(program, id)


module.config stateDefinitions